"use client";

import { c as _c } from "react/compiler-runtime";
import { HiOutlineBell } from "react-icons/hi2";
import { Button } from "@/components/ui";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useBrowserNotificationPermission } from "@/hooks/use-browser-notification-permission";
export function BrowserNotificationsBanner() {
  const $ = _c(3);
  const {
    permission,
    isInitialized,
    request
  } = useBrowserNotificationPermission();
  if (!isInitialized || permission !== "default") {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AlertDescription className="flex-1">Turn on desktop notifications to hear about these while you are working in another tab or another app.</AlertDescription>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== request) {
    t1 = <Alert variant="default" icon={HiOutlineBell} className="rounded-none border-x-0 border-t-0 px-4 py-2.5"><div className="flex items-center gap-3">{t0}<Button size="sm" variant="primary" onClick={() => request()}>Enable</Button></div></Alert>;
    $[1] = request;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}